import Swal from "sweetalert2";
import { MutantApiService } from "../../../../services/MutantApiService";

const api = new MutantApiService();

export const getProviders = async (setState) => {
	try {
		const response = await api.makeHttpRequest({ url: "/provider?status=active" });
		const providersArr = Array.isArray(response)
			? response
			: Array.isArray(response?.data)
			? response.data
			: Array.isArray(response?.data?.data)
			? response.data.data
			: [];

		setState((prevState) => ({ ...prevState, providers: providersArr }));
		return providersArr;
	} catch (e) {
		console.log("Error getting providers", e);
		return [];
	}
};

export const getModels = async (provider, setState, defaultProvider) => {
	try {
		const url = provider ? `/models?provider=${provider}&statusFilter=active` : `/models?statusFilter=active&perPage=1000`;
		const response = await api.makeHttpRequest({ url });

		const modelsArr = Array.isArray(response)
			? response
			: Array.isArray(response?.data)
			? response.data
			: Array.isArray(response?.data?.data)
			? response.data.data
			: [];

		if (provider) {
			// explicit provider requested: keep all models for that provider
			setState((prevState) => ({ ...prevState, models: modelsArr }));
			return modelsArr;
		}

		// Show all models when no explicit provider is requested.
		// Previously this code filtered models to the default provider or Eleven Labs only.
		// To expose all voices in the form, set the full models list.
		setState((prevState) => ({ ...prevState, models: modelsArr }));
		return modelsArr;
	} catch (e) {
		console.log("Error getting models", e);
		setState((prevState) => ({ ...prevState, models: [] }));
		return [];
	}
};

export const getVcSpeakers = async (provider, setState) => {
	if (!provider) {
		setState((prevState) => ({ ...prevState, vcSpeakers: [] }));
		return;
	}

	try {
		const response = await api.makeHttpRequest({ url: `/models/voice-cloning-speakers?provider=${provider}` });
		setState((prevState) => ({ ...prevState, vcSpeakers: response ?? [] }));
	} catch (e) {
		console.log("Error getting vc speakers", e);
		setState((prevState) => ({ ...prevState, vcSpeakers: [] }));
	}
};

export const fetchData = async (props, state, setState) => {
	setState((prevState) => ({ ...prevState, isLoading: true }));

	let promptData = {};
	if (state.isEditing) {
		try {
			promptData = await api.makeHttpRequest({ method: "GET", url: `/prompts/${props.match.params.id}`, timeout: 15000 });
			console.log("Prompt data loaded:", promptData);
		} catch (e) {
			console.error("Error loading prompt data:", e);
		}
	}

	// load providers and determine default provider
	const providers = await getProviders(setState);
	const defaultProviderName = Array.isArray(providers) ? (providers.find((p) => p.default === true)?.name ?? "") : "";

	// if editing and prompt belongs to a specific provider, load that provider's models
	if (state.isEditing && promptData && promptData.provider) {
		await getModels(promptData.provider, setState, defaultProviderName);
	} else {
		await getModels(null, setState, defaultProviderName);
	}

	if (state.isEditing && promptData) {
		setState((prevState) => ({ ...prevState, ...promptData, isLoading: false }));

		if (promptData.provider) {
			await getVcSpeakers(promptData.provider, setState);
		}
	} else {
		setState((prevState) => ({ ...prevState, isLoading: false }));
	}
};

export const getFormData = async (state, props) => {
	const formData = new FormData();
	const derivedProvider = state.provider ?? (state.models || []).find((m) => (m.name ?? m.model ?? "") === state?.speaker)?.provider ?? "";
	formData.append("provider", derivedProvider);
	formData.append("speaker", state.speaker);
	formData.append("compression", String(state.compression));
	formData.append("idProject", String(props.match?.params?.idProject));
	formData.append("vcSpeaker", state?.vcSpeaker);
	if (state?.preset) {
		formData.append("presetId", state?.preset?.value ?? state?.preset);
	}
	if (state.text) {
		formData.append("name", state?.name);
		formData.append("text", state?.text);
	} else {
		formData.append("name", state.selectedFile.name);
		formData.append("file", state.selectedFile);
	}
	return formData;
};

export const afterSubmit = async (setState, initialState, history) => {
	setState({ ...initialState, resetInput: true });

	await Swal.fire({ title: "Sucesso!", text: "Dados salvos com sucesso.", icon: "success", showCancelButton: false, showConfirmButton: true, confirmButtonText: "Voltar" });

	history.goBack();
};
